import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

let newResidentialsimgPath = require.context("../../public/images/newResidential", true);
let remodelsimgPath = require.context("../../public/images/remodels", true);
let seismicimgPath = require.context("../../public/images/seismic", true);
let commercialimgPath = require.context("../../public/images/commercial", true);

const categories = [
	{
		title: "New Residential",
		path: "/projects/residential",
		image: newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA1.jpg")
	},
	{
		title: "Remodeling & Additions",
		path: "/projects/remodels",
		image: remodelsimgPath("./Iris Street, San Francisco, CA1.jpg")
	},
	{
		title: "Seismic Retrofit",
		path: "/projects/seismic-retrofit",
		image: seismicimgPath("./Steiner St, San Francisco, CA1.jpg")
	},
	{
		title: "Commercial & Industrial",
		path: "/projects/commercial",
		image: commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)1.jpg")
	}
];

const slides = [
	remodelsimgPath("./Chelmsford Rd, Hillsborough, CA2.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)4.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)6.jpg"),
	remodelsimgPath("./Laidley Street, San Francisco, CA2.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA12.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA2.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)7.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA10.jpg"),
	remodelsimgPath("./25th Avenue, San Francisco, CA4.jpg"),
	newResidentialsimgPath("./Skyfarm Drive, Santa Rosa, CA6.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA5.jpg")
];

const SLIDE_INTERVAL = 3500;

const Projects = () => {
	const [activeSlide, setActiveSlide] = useState(0);

	useEffect(() => {
		const timer = window.setInterval(() => {
			setActiveSlide(current => (current + 1) % slides.length);
		}, SLIDE_INTERVAL);

		return () => window.clearInterval(timer);
	}, []);

	return (
		<main className="projects-page">
			<section className="projects-hero-slideshow custom-slideshow">
				{slides.map((slide, index) => (
					<img
						key={index}
						src={slide}
						alt="NY Engineering project slideshow"
						className={index === activeSlide ? "active" : ""}
					/>
				))}
			</section>

			<section className="site-section project-categories-section">
				<div className="site-container">
					<div className="section-header simple-section-header">
						<div>
							<div className="section-label">Projects</div>
							<h2>Project Categories</h2>
						</div>
					</div>
					<div className="project-category-grid">
						{categories.map(category => (
							<Link className="category-card category-card-overlay" to={category.path} key={category.title}>
								<img src={category.image} alt={category.title} />
								<div className="category-card-title"><h2>{category.title}</h2></div>
							</Link>
						))}
					</div>
				</div>
			</section>
		</main>
	);
};

export default Projects;
